window.addEventListener("turbo:load", () => {   
  const todayWorkingText = document.querySelector("#today-working-text");
  const openingHours = document.querySelector("#opening-hours");
  if (!openingHours) return;
  const transformed = openingHours.innerText.replaceAll("=>", ":");
  const jsonData = JSON.parse(transformed);
  const currentDate = new Date();
  const currentDay = currentDate.toLocaleString(
    'en-US', {weekday: 'long'}
  ).toLowerCase();
  let currentDayTimes;
  let yesterdayTimes = jsonData.sunday;
  for (var key of Object.keys(jsonData)) {
    if(currentDay == key){
      currentDayTimes = jsonData[key];
      break;
    }
    yesterdayTimes = jsonData[key];
  }
  const currentTime = (currentDate.getHours() < 10 ? "0" : "") + currentDate.getHours() + ":" + (currentDate.getMinutes() < 10 ? "0" : "") + currentDate.getMinutes();
  if (current_locale === "en"){
    var translations = { 
      opened: "Open now",
      closed: "Closed"
    }
  } else{
    var translations = { 
      opened: "Jetzt geöffnet", 
      closed: "Jetzt geschlossen"
    }
  }

  todayWorkingText.innerText = translations.closed;
  todayWorkingText.classList.add("closed");


  if(currentDayTimes){
      currentDayTimes.forEach(element => {
      if((currentTime >= element.from && currentTime <= element.to) || (currentTime >= element.from && currentTime >= element.to && element.to <= element.from) || (yesterdayTimes[yesterdayTimes.length - 1].to >= currentTime && yesterdayTimes[yesterdayTimes.length - 1].to < yesterdayTimes[yesterdayTimes.length - 1].from)){
        todayWorkingText.innerText = translations.opened;
        todayWorkingText.classList.remove("closed");
        todayWorkingText.classList.add("open");
        return;
      }
    });
  }
});